type GraphqlResponseError = {
  response?: {
    errors?: { extensions?: { code?: string } }[];
  };
};

// True only when the response has at least one NOT_FOUND error and no other
// error types. A mixed response (NOT_FOUND + internal/permission error) must
// still surface as an error rather than being treated as a "not found" case.
export const isGqlNotFoundError = (error: unknown): boolean => {
  const errors = (error as GraphqlResponseError)?.response?.errors;
  return (
    !!errors?.length && errors.every((e) => e?.extensions?.code === 'NOT_FOUND')
  );
};
